/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.produkty-grid.title",
    defaultMessage: "Products"
  },
  add: {
    id: "b2b.produkty-grid.add",
    defaultMessage: "Add product"
  }
});

export default () => useMessages(MESSAGES);
